import * as React from "react";
import DividerMaterialUI from "material-ui/Divider";
import {divider} from "colors";

interface DividerProps {
   fullHeight?: boolean;
}

export const Divider: React.StatelessComponent<DividerProps> = props => {
   const margin = props.fullHeight ? { marginTop: 0 } : {};
   return <DividerMaterialUI style={{backgroundColor: divider, ...margin}}/>;
};

export default Divider;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Divider/Divider.tsx